/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as SignInIndexImport } from './routes/sign-in/index'
import { Route as LoginIndexImport } from './routes/login/index'
import { Route as ForgotPasswordIndexImport } from './routes/forgot-password/index'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as PasswordSetupAuthTokenImport } from './routes/password-setup/$authToken'
import { Route as AuthenticatedOnboardingImport } from './routes/_authenticated/_onboarding'
import { Route as AuthenticatedMemberCareImport } from './routes/_authenticated/_member-care'
import { Route as AuthenticatedAdminImport } from './routes/_authenticated/_admin'
import { Route as AuthenticatedSettingsIndexImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedAdminProvidersIndexImport } from './routes/_authenticated/_admin/providers/index'
import { Route as AuthenticatedAdminOrganizationsIndexImport } from './routes/_authenticated/_admin/organizations/index'
import { Route as AuthenticatedAdminOrganizationLeadsIndexImport } from './routes/_authenticated/_admin/organization-leads/index'
import { Route as AuthenticatedAdminNotificationsIndexImport } from './routes/_authenticated/_admin/notifications/index'
import { Route as AuthenticatedAdminMemberCareIndexImport } from './routes/_authenticated/_admin/member-care/index'
import { Route as AuthenticatedAdminEulaIndexImport } from './routes/_authenticated/_admin/eula/index'
import { Route as AuthenticatedAdminCreatorApplicationsIndexImport } from './routes/_authenticated/_admin/creator-applications/index'
import { Route as AuthenticatedAdminContractsIndexImport } from './routes/_authenticated/_admin/contracts/index'
import { Route as AuthenticatedAdminAssessmentsIndexImport } from './routes/_authenticated/_admin/assessments/index'
import { Route as AuthenticatedOnboardingOnboardingMemberCareImport } from './routes/_authenticated/_onboarding/onboarding.member-care'
import { Route as AuthenticatedAdminSuperAdminOrganizationAccessImport } from './routes/_authenticated/_admin/super-admin/organization-access'
import { Route as AuthenticatedAdminSuperAdminMetricsImport } from './routes/_authenticated/_admin/super-admin/metrics'
import { Route as AuthenticatedAdminSuperAdminManualQueuesImport } from './routes/_authenticated/_admin/super-admin/manual-queues'
import { Route as AuthenticatedAdminSuperAdminFeaturesManagementImport } from './routes/_authenticated/_admin/super-admin/features-management'
import { Route as AuthenticatedAdminProvidersProviderIdImport } from './routes/_authenticated/_admin/providers/$providerId'
import { Route as AuthenticatedAdminOrganizationsOrganizationIdImport } from './routes/_authenticated/_admin/organizations/$organizationId'
import { Route as AuthenticatedAdminMemberCareMemberCareIdImport } from './routes/_authenticated/_admin/member-care/$memberCareId'
import { Route as AuthenticatedAdminEulaIdImport } from './routes/_authenticated/_admin/eula/$id'
import { Route as AuthenticatedAdminCreatorApplicationsApplicationIdImport } from './routes/_authenticated/_admin/creator-applications/$applicationId'
import { Route as AuthenticatedMemberCareMemberCareProfileIndexImport } from './routes/_authenticated/_member-care/member-care/profile/index'
import { Route as AuthenticatedMemberCareMemberCareMembersIndexImport } from './routes/_authenticated/_member-care/member-care/members/index'
import { Route as AuthenticatedAdminProvidersCreateIndexImport } from './routes/_authenticated/_admin/providers/create/index'
import { Route as AuthenticatedAdminContentModerationIndexImport } from './routes/_authenticated/_admin/content/moderation/index'
import { Route as AuthenticatedAdminContentBrandedContentIndexImport } from './routes/_authenticated/_admin/content/branded-content/index'
import { Route as AuthenticatedAdminAssessmentsAssessmentIdIndexImport } from './routes/_authenticated/_admin/assessments/$assessmentId/index'
import { Route as AuthenticatedMemberCareMemberCareOrganizationsMemberCareOrganizationIdImport } from './routes/_authenticated/_member-care/member-care/organizations/$memberCareOrganizationId'
import { Route as AuthenticatedMemberCareMemberCareMembersMemberCareMemberIdImport } from './routes/_authenticated/_member-care/member-care/members/$memberCareMemberId'
import { Route as AuthenticatedAdminContentModerationContentIdImport } from './routes/_authenticated/_admin/content/moderation/$contentId'
import { Route as AuthenticatedAdminContentBrandedContentContentIdImport } from './routes/_authenticated/_admin/content/branded-content/$contentId'
import { Route as AuthenticatedAdminAssessmentsAssessmentIdPreviewImport } from './routes/_authenticated/_admin/assessments/$assessmentId/preview'
import { Route as AuthenticatedMemberCareMemberCareProfileContactIndexImport } from './routes/_authenticated/_member-care/member-care/profile/contact/index'
import { Route as AuthenticatedMemberCareMemberCareProfileBioIndexImport } from './routes/_authenticated/_member-care/member-care/profile/bio/index'
import { Route as AuthenticatedAdminContentBrandedContentCreateTypeImport } from './routes/_authenticated/_admin/content/branded-content/create/$type'

// Create/Update Routes

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const SignInIndexRoute = SignInIndexImport.update({
  path: '/sign-in/',
  getParentRoute: () => rootRoute,
} as any)

const LoginIndexRoute = LoginIndexImport.update({
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordIndexRoute = ForgotPasswordIndexImport.update({
  path: '/forgot-password/',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const PasswordSetupAuthTokenRoute = PasswordSetupAuthTokenImport.update({
  path: '/password-setup/$authToken',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedOnboardingRoute = AuthenticatedOnboardingImport.update({
  id: '/_onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedMemberCareRoute = AuthenticatedMemberCareImport.update({
  id: '/_member-care',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedAdminRoute = AuthenticatedAdminImport.update({
  id: '/_admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedSettingsIndexRoute = AuthenticatedSettingsIndexImport.update(
  {
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any,
)

const AuthenticatedAdminProvidersIndexRoute =
  AuthenticatedAdminProvidersIndexImport.update({
    path: '/providers/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminOrganizationsIndexRoute =
  AuthenticatedAdminOrganizationsIndexImport.update({
    path: '/organizations/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminOrganizationLeadsIndexRoute =
  AuthenticatedAdminOrganizationLeadsIndexImport.update({
    path: '/organization-leads/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminNotificationsIndexRoute =
  AuthenticatedAdminNotificationsIndexImport.update({
    path: '/notifications/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminMemberCareIndexRoute =
  AuthenticatedAdminMemberCareIndexImport.update({
    path: '/member-care/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminEulaIndexRoute =
  AuthenticatedAdminEulaIndexImport.update({
    path: '/eula/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminCreatorApplicationsIndexRoute =
  AuthenticatedAdminCreatorApplicationsIndexImport.update({
    path: '/creator-applications/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminContractsIndexRoute =
  AuthenticatedAdminContractsIndexImport.update({
    path: '/contracts/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminAssessmentsIndexRoute =
  AuthenticatedAdminAssessmentsIndexImport.update({
    path: '/assessments/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedOnboardingOnboardingMemberCareRoute =
  AuthenticatedOnboardingOnboardingMemberCareImport.update({
    path: '/onboarding/member-care',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)

const AuthenticatedAdminSuperAdminOrganizationAccessRoute =
  AuthenticatedAdminSuperAdminOrganizationAccessImport.update({
    path: '/super-admin/organization-access',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminSuperAdminMetricsRoute =
  AuthenticatedAdminSuperAdminMetricsImport.update({
    path: '/super-admin/metrics',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminSuperAdminManualQueuesRoute =
  AuthenticatedAdminSuperAdminManualQueuesImport.update({
    path: '/super-admin/manual-queues',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminSuperAdminFeaturesManagementRoute =
  AuthenticatedAdminSuperAdminFeaturesManagementImport.update({
    path: '/super-admin/features-management',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminProvidersProviderIdRoute =
  AuthenticatedAdminProvidersProviderIdImport.update({
    path: '/providers/$providerId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminOrganizationsOrganizationIdRoute =
  AuthenticatedAdminOrganizationsOrganizationIdImport.update({
    path: '/organizations/$organizationId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminMemberCareMemberCareIdRoute =
  AuthenticatedAdminMemberCareMemberCareIdImport.update({
    path: '/member-care/$memberCareId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminEulaIdRoute = AuthenticatedAdminEulaIdImport.update({
  path: '/eula/$id',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)

const AuthenticatedAdminCreatorApplicationsApplicationIdRoute =
  AuthenticatedAdminCreatorApplicationsApplicationIdImport.update({
    path: '/creator-applications/$applicationId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedMemberCareMemberCareProfileIndexRoute =
  AuthenticatedMemberCareMemberCareProfileIndexImport.update({
    path: '/member-care/profile/',
    getParentRoute: () => AuthenticatedMemberCareRoute,
  } as any)

const AuthenticatedMemberCareMemberCareMembersIndexRoute =
  AuthenticatedMemberCareMemberCareMembersIndexImport.update({
    path: '/member-care/members/',
    getParentRoute: () => AuthenticatedMemberCareRoute,
  } as any)

const AuthenticatedAdminProvidersCreateIndexRoute =
  AuthenticatedAdminProvidersCreateIndexImport.update({
    path: '/providers/create/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminContentModerationIndexRoute =
  AuthenticatedAdminContentModerationIndexImport.update({
    path: '/content/moderation/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminContentBrandedContentIndexRoute =
  AuthenticatedAdminContentBrandedContentIndexImport.update({
    path: '/content/branded-content/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminAssessmentsAssessmentIdIndexRoute =
  AuthenticatedAdminAssessmentsAssessmentIdIndexImport.update({
    path: '/assessments/$assessmentId/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedMemberCareMemberCareOrganizationsMemberCareOrganizationIdRoute =
  AuthenticatedMemberCareMemberCareOrganizationsMemberCareOrganizationIdImport.update(
    {
      path: '/member-care/organizations/$memberCareOrganizationId',
      getParentRoute: () => AuthenticatedMemberCareRoute,
    } as any,
  )

const AuthenticatedMemberCareMemberCareMembersMemberCareMemberIdRoute =
  AuthenticatedMemberCareMemberCareMembersMemberCareMemberIdImport.update({
    path: '/member-care/members/$memberCareMemberId',
    getParentRoute: () => AuthenticatedMemberCareRoute,
  } as any)

const AuthenticatedAdminContentModerationContentIdRoute =
  AuthenticatedAdminContentModerationContentIdImport.update({
    path: '/content/moderation/$contentId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminContentBrandedContentContentIdRoute =
  AuthenticatedAdminContentBrandedContentContentIdImport.update({
    path: '/content/branded-content/$contentId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedAdminAssessmentsAssessmentIdPreviewRoute =
  AuthenticatedAdminAssessmentsAssessmentIdPreviewImport.update({
    path: '/assessments/$assessmentId/preview',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

const AuthenticatedMemberCareMemberCareProfileContactIndexRoute =
  AuthenticatedMemberCareMemberCareProfileContactIndexImport.update({
    path: '/member-care/profile/contact/',
    getParentRoute: () => AuthenticatedMemberCareRoute,
  } as any)

const AuthenticatedMemberCareMemberCareProfileBioIndexRoute =
  AuthenticatedMemberCareMemberCareProfileBioIndexImport.update({
    path: '/member-care/profile/bio/',
    getParentRoute: () => AuthenticatedMemberCareRoute,
  } as any)

const AuthenticatedAdminContentBrandedContentCreateTypeRoute =
  AuthenticatedAdminContentBrandedContentCreateTypeImport.update({
    path: '/content/branded-content/create/$type',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/_admin': {
      id: '/_authenticated/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedAdminImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_member-care': {
      id: '/_authenticated/_member-care'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedMemberCareImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_onboarding': {
      id: '/_authenticated/_onboarding'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedOnboardingImport
      parentRoute: typeof AuthenticatedImport
    }
    '/password-setup/$authToken': {
      id: '/password-setup/$authToken'
      path: '/password-setup/$authToken'
      fullPath: '/password-setup/$authToken'
      preLoaderRoute: typeof PasswordSetupAuthTokenImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/forgot-password/': {
      id: '/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/sign-in/': {
      id: '/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_admin/creator-applications/$applicationId': {
      id: '/_authenticated/_admin/creator-applications/$applicationId'
      path: '/creator-applications/$applicationId'
      fullPath: '/creator-applications/$applicationId'
      preLoaderRoute: typeof AuthenticatedAdminCreatorApplicationsApplicationIdImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/eula/$id': {
      id: '/_authenticated/_admin/eula/$id'
      path: '/eula/$id'
      fullPath: '/eula/$id'
      preLoaderRoute: typeof AuthenticatedAdminEulaIdImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/member-care/$memberCareId': {
      id: '/_authenticated/_admin/member-care/$memberCareId'
      path: '/member-care/$memberCareId'
      fullPath: '/member-care/$memberCareId'
      preLoaderRoute: typeof AuthenticatedAdminMemberCareMemberCareIdImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/organizations/$organizationId': {
      id: '/_authenticated/_admin/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/organizations/$organizationId'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/providers/$providerId': {
      id: '/_authenticated/_admin/providers/$providerId'
      path: '/providers/$providerId'
      fullPath: '/providers/$providerId'
      preLoaderRoute: typeof AuthenticatedAdminProvidersProviderIdImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/super-admin/features-management': {
      id: '/_authenticated/_admin/super-admin/features-management'
      path: '/super-admin/features-management'
      fullPath: '/super-admin/features-management'
      preLoaderRoute: typeof AuthenticatedAdminSuperAdminFeaturesManagementImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/super-admin/manual-queues': {
      id: '/_authenticated/_admin/super-admin/manual-queues'
      path: '/super-admin/manual-queues'
      fullPath: '/super-admin/manual-queues'
      preLoaderRoute: typeof AuthenticatedAdminSuperAdminManualQueuesImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/super-admin/metrics': {
      id: '/_authenticated/_admin/super-admin/metrics'
      path: '/super-admin/metrics'
      fullPath: '/super-admin/metrics'
      preLoaderRoute: typeof AuthenticatedAdminSuperAdminMetricsImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/super-admin/organization-access': {
      id: '/_authenticated/_admin/super-admin/organization-access'
      path: '/super-admin/organization-access'
      fullPath: '/super-admin/organization-access'
      preLoaderRoute: typeof AuthenticatedAdminSuperAdminOrganizationAccessImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_onboarding/onboarding/member-care': {
      id: '/_authenticated/_onboarding/onboarding/member-care'
      path: '/onboarding/member-care'
      fullPath: '/onboarding/member-care'
      preLoaderRoute: typeof AuthenticatedOnboardingOnboardingMemberCareImport
      parentRoute: typeof AuthenticatedOnboardingImport
    }
    '/_authenticated/_admin/assessments/': {
      id: '/_authenticated/_admin/assessments/'
      path: '/assessments'
      fullPath: '/assessments'
      preLoaderRoute: typeof AuthenticatedAdminAssessmentsIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/contracts/': {
      id: '/_authenticated/_admin/contracts/'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof AuthenticatedAdminContractsIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/creator-applications/': {
      id: '/_authenticated/_admin/creator-applications/'
      path: '/creator-applications'
      fullPath: '/creator-applications'
      preLoaderRoute: typeof AuthenticatedAdminCreatorApplicationsIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/eula/': {
      id: '/_authenticated/_admin/eula/'
      path: '/eula'
      fullPath: '/eula'
      preLoaderRoute: typeof AuthenticatedAdminEulaIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/member-care/': {
      id: '/_authenticated/_admin/member-care/'
      path: '/member-care'
      fullPath: '/member-care'
      preLoaderRoute: typeof AuthenticatedAdminMemberCareIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/notifications/': {
      id: '/_authenticated/_admin/notifications/'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedAdminNotificationsIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/organization-leads/': {
      id: '/_authenticated/_admin/organization-leads/'
      path: '/organization-leads'
      fullPath: '/organization-leads'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationLeadsIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/organizations/': {
      id: '/_authenticated/_admin/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/providers/': {
      id: '/_authenticated/_admin/providers/'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof AuthenticatedAdminProvidersIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/assessments/$assessmentId/preview': {
      id: '/_authenticated/_admin/assessments/$assessmentId/preview'
      path: '/assessments/$assessmentId/preview'
      fullPath: '/assessments/$assessmentId/preview'
      preLoaderRoute: typeof AuthenticatedAdminAssessmentsAssessmentIdPreviewImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/content/branded-content/$contentId': {
      id: '/_authenticated/_admin/content/branded-content/$contentId'
      path: '/content/branded-content/$contentId'
      fullPath: '/content/branded-content/$contentId'
      preLoaderRoute: typeof AuthenticatedAdminContentBrandedContentContentIdImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/content/moderation/$contentId': {
      id: '/_authenticated/_admin/content/moderation/$contentId'
      path: '/content/moderation/$contentId'
      fullPath: '/content/moderation/$contentId'
      preLoaderRoute: typeof AuthenticatedAdminContentModerationContentIdImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_member-care/member-care/members/$memberCareMemberId': {
      id: '/_authenticated/_member-care/member-care/members/$memberCareMemberId'
      path: '/member-care/members/$memberCareMemberId'
      fullPath: '/member-care/members/$memberCareMemberId'
      preLoaderRoute: typeof AuthenticatedMemberCareMemberCareMembersMemberCareMemberIdImport
      parentRoute: typeof AuthenticatedMemberCareImport
    }
    '/_authenticated/_member-care/member-care/organizations/$memberCareOrganizationId': {
      id: '/_authenticated/_member-care/member-care/organizations/$memberCareOrganizationId'
      path: '/member-care/organizations/$memberCareOrganizationId'
      fullPath: '/member-care/organizations/$memberCareOrganizationId'
      preLoaderRoute: typeof AuthenticatedMemberCareMemberCareOrganizationsMemberCareOrganizationIdImport
      parentRoute: typeof AuthenticatedMemberCareImport
    }
    '/_authenticated/_admin/assessments/$assessmentId/': {
      id: '/_authenticated/_admin/assessments/$assessmentId/'
      path: '/assessments/$assessmentId'
      fullPath: '/assessments/$assessmentId'
      preLoaderRoute: typeof AuthenticatedAdminAssessmentsAssessmentIdIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/content/branded-content/': {
      id: '/_authenticated/_admin/content/branded-content/'
      path: '/content/branded-content'
      fullPath: '/content/branded-content'
      preLoaderRoute: typeof AuthenticatedAdminContentBrandedContentIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/content/moderation/': {
      id: '/_authenticated/_admin/content/moderation/'
      path: '/content/moderation'
      fullPath: '/content/moderation'
      preLoaderRoute: typeof AuthenticatedAdminContentModerationIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_admin/providers/create/': {
      id: '/_authenticated/_admin/providers/create/'
      path: '/providers/create'
      fullPath: '/providers/create'
      preLoaderRoute: typeof AuthenticatedAdminProvidersCreateIndexImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_member-care/member-care/members/': {
      id: '/_authenticated/_member-care/member-care/members/'
      path: '/member-care/members'
      fullPath: '/member-care/members'
      preLoaderRoute: typeof AuthenticatedMemberCareMemberCareMembersIndexImport
      parentRoute: typeof AuthenticatedMemberCareImport
    }
    '/_authenticated/_member-care/member-care/profile/': {
      id: '/_authenticated/_member-care/member-care/profile/'
      path: '/member-care/profile'
      fullPath: '/member-care/profile'
      preLoaderRoute: typeof AuthenticatedMemberCareMemberCareProfileIndexImport
      parentRoute: typeof AuthenticatedMemberCareImport
    }
    '/_authenticated/_admin/content/branded-content/create/$type': {
      id: '/_authenticated/_admin/content/branded-content/create/$type'
      path: '/content/branded-content/create/$type'
      fullPath: '/content/branded-content/create/$type'
      preLoaderRoute: typeof AuthenticatedAdminContentBrandedContentCreateTypeImport
      parentRoute: typeof AuthenticatedAdminImport
    }
    '/_authenticated/_member-care/member-care/profile/bio/': {
      id: '/_authenticated/_member-care/member-care/profile/bio/'
      path: '/member-care/profile/bio'
      fullPath: '/member-care/profile/bio'
      preLoaderRoute: typeof AuthenticatedMemberCareMemberCareProfileBioIndexImport
      parentRoute: typeof AuthenticatedMemberCareImport
    }
    '/_authenticated/_member-care/member-care/profile/contact/': {
      id: '/_authenticated/_member-care/member-care/profile/contact/'
      path: '/member-care/profile/contact'
      fullPath: '/member-care/profile/contact'
      preLoaderRoute: typeof AuthenticatedMemberCareMemberCareProfileContactIndexImport
      parentRoute: typeof AuthenticatedMemberCareImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminCreatorApplicationsApplicationIdRoute: typeof AuthenticatedAdminCreatorApplicationsApplicationIdRoute
  AuthenticatedAdminEulaIdRoute: typeof AuthenticatedAdminEulaIdRoute
  AuthenticatedAdminMemberCareMemberCareIdRoute: typeof AuthenticatedAdminMemberCareMemberCareIdRoute
  AuthenticatedAdminOrganizationsOrganizationIdRoute: typeof AuthenticatedAdminOrganizationsOrganizationIdRoute
  AuthenticatedAdminProvidersProviderIdRoute: typeof AuthenticatedAdminProvidersProviderIdRoute
  AuthenticatedAdminSuperAdminFeaturesManagementRoute: typeof AuthenticatedAdminSuperAdminFeaturesManagementRoute
  AuthenticatedAdminSuperAdminManualQueuesRoute: typeof AuthenticatedAdminSuperAdminManualQueuesRoute
  AuthenticatedAdminSuperAdminMetricsRoute: typeof AuthenticatedAdminSuperAdminMetricsRoute
  AuthenticatedAdminSuperAdminOrganizationAccessRoute: typeof AuthenticatedAdminSuperAdminOrganizationAccessRoute
  AuthenticatedAdminAssessmentsIndexRoute: typeof AuthenticatedAdminAssessmentsIndexRoute
  AuthenticatedAdminContractsIndexRoute: typeof AuthenticatedAdminContractsIndexRoute
  AuthenticatedAdminCreatorApplicationsIndexRoute: typeof AuthenticatedAdminCreatorApplicationsIndexRoute
  AuthenticatedAdminEulaIndexRoute: typeof AuthenticatedAdminEulaIndexRoute
  AuthenticatedAdminMemberCareIndexRoute: typeof AuthenticatedAdminMemberCareIndexRoute
  AuthenticatedAdminNotificationsIndexRoute: typeof AuthenticatedAdminNotificationsIndexRoute
  AuthenticatedAdminOrganizationLeadsIndexRoute: typeof AuthenticatedAdminOrganizationLeadsIndexRoute
  AuthenticatedAdminOrganizationsIndexRoute: typeof AuthenticatedAdminOrganizationsIndexRoute
  AuthenticatedAdminProvidersIndexRoute: typeof AuthenticatedAdminProvidersIndexRoute
  AuthenticatedAdminAssessmentsAssessmentIdPreviewRoute: typeof AuthenticatedAdminAssessmentsAssessmentIdPreviewRoute
  AuthenticatedAdminContentBrandedContentContentIdRoute: typeof AuthenticatedAdminContentBrandedContentContentIdRoute
  AuthenticatedAdminContentModerationContentIdRoute: typeof AuthenticatedAdminContentModerationContentIdRoute
  AuthenticatedAdminAssessmentsAssessmentIdIndexRoute: typeof AuthenticatedAdminAssessmentsAssessmentIdIndexRoute
  AuthenticatedAdminContentBrandedContentIndexRoute: typeof AuthenticatedAdminContentBrandedContentIndexRoute
  AuthenticatedAdminContentModerationIndexRoute: typeof AuthenticatedAdminContentModerationIndexRoute
  AuthenticatedAdminProvidersCreateIndexRoute: typeof AuthenticatedAdminProvidersCreateIndexRoute
  AuthenticatedAdminContentBrandedContentCreateTypeRoute: typeof AuthenticatedAdminContentBrandedContentCreateTypeRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminCreatorApplicationsApplicationIdRoute:
    AuthenticatedAdminCreatorApplicationsApplicationIdRoute,
  AuthenticatedAdminEulaIdRoute: AuthenticatedAdminEulaIdRoute,
  AuthenticatedAdminMemberCareMemberCareIdRoute:
    AuthenticatedAdminMemberCareMemberCareIdRoute,
  AuthenticatedAdminOrganizationsOrganizationIdRoute:
    AuthenticatedAdminOrganizationsOrganizationIdRoute,
  AuthenticatedAdminProvidersProviderIdRoute:
    AuthenticatedAdminProvidersProviderIdRoute,
  AuthenticatedAdminSuperAdminFeaturesManagementRoute:
    AuthenticatedAdminSuperAdminFeaturesManagementRoute,
  AuthenticatedAdminSuperAdminManualQueuesRoute:
    AuthenticatedAdminSuperAdminManualQueuesRoute,
  AuthenticatedAdminSuperAdminMetricsRoute:
    AuthenticatedAdminSuperAdminMetricsRoute,
  AuthenticatedAdminSuperAdminOrganizationAccessRoute:
    AuthenticatedAdminSuperAdminOrganizationAccessRoute,
  AuthenticatedAdminAssessmentsIndexRoute:
    AuthenticatedAdminAssessmentsIndexRoute,
  AuthenticatedAdminContractsIndexRoute: AuthenticatedAdminContractsIndexRoute,
  AuthenticatedAdminCreatorApplicationsIndexRoute:
    AuthenticatedAdminCreatorApplicationsIndexRoute,
  AuthenticatedAdminEulaIndexRoute: AuthenticatedAdminEulaIndexRoute,
  AuthenticatedAdminMemberCareIndexRoute:
    AuthenticatedAdminMemberCareIndexRoute,
  AuthenticatedAdminNotificationsIndexRoute:
    AuthenticatedAdminNotificationsIndexRoute,
  AuthenticatedAdminOrganizationLeadsIndexRoute:
    AuthenticatedAdminOrganizationLeadsIndexRoute,
  AuthenticatedAdminOrganizationsIndexRoute:
    AuthenticatedAdminOrganizationsIndexRoute,
  AuthenticatedAdminProvidersIndexRoute: AuthenticatedAdminProvidersIndexRoute,
  AuthenticatedAdminAssessmentsAssessmentIdPreviewRoute:
    AuthenticatedAdminAssessmentsAssessmentIdPreviewRoute,
  AuthenticatedAdminContentBrandedContentContentIdRoute:
    AuthenticatedAdminContentBrandedContentContentIdRoute,
  AuthenticatedAdminContentModerationContentIdRoute:
    AuthenticatedAdminContentModerationContentIdRoute,
  AuthenticatedAdminAssessmentsAssessmentIdIndexRoute:
    AuthenticatedAdminAssessmentsAssessmentIdIndexRoute,
  AuthenticatedAdminContentBrandedContentIndexRoute:
    AuthenticatedAdminContentBrandedContentIndexRoute,
  AuthenticatedAdminContentModerationIndexRoute:
    AuthenticatedAdminContentModerationIndexRoute,
  AuthenticatedAdminProvidersCreateIndexRoute:
    AuthenticatedAdminProvidersCreateIndexRoute,
  AuthenticatedAdminContentBrandedContentCreateTypeRoute:
    AuthenticatedAdminContentBrandedContentCreateTypeRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedMemberCareRouteChildren {
  AuthenticatedMemberCareMemberCareMembersMemberCareMemberIdRoute: typeof AuthenticatedMemberCareMemberCareMembersMemberCareMemberIdRoute
  AuthenticatedMemberCareMemberCareOrganizationsMemberCareOrganizationIdRoute: typeof AuthenticatedMemberCareMemberCareOrganizationsMemberCareOrganizationIdRoute
  AuthenticatedMemberCareMemberCareMembersIndexRoute: typeof AuthenticatedMemberCareMemberCareMembersIndexRoute
  AuthenticatedMemberCareMemberCareProfileIndexRoute: typeof AuthenticatedMemberCareMemberCareProfileIndexRoute
  AuthenticatedMemberCareMemberCareProfileBioIndexRoute: typeof AuthenticatedMemberCareMemberCareProfileBioIndexRoute
  AuthenticatedMemberCareMemberCareProfileContactIndexRoute: typeof AuthenticatedMemberCareMemberCareProfileContactIndexRoute
}

const AuthenticatedMemberCareRouteChildren: AuthenticatedMemberCareRouteChildren =
  {
    AuthenticatedMemberCareMemberCareMembersMemberCareMemberIdRoute:
      AuthenticatedMemberCareMemberCareMembersMemberCareMemberIdRoute,
    AuthenticatedMemberCareMemberCareOrganizationsMemberCareOrganizationIdRoute:
      AuthenticatedMemberCareMemberCareOrganizationsMemberCareOrganizationIdRoute,
    AuthenticatedMemberCareMemberCareMembersIndexRoute:
      AuthenticatedMemberCareMemberCareMembersIndexRoute,
    AuthenticatedMemberCareMemberCareProfileIndexRoute:
      AuthenticatedMemberCareMemberCareProfileIndexRoute,
    AuthenticatedMemberCareMemberCareProfileBioIndexRoute:
      AuthenticatedMemberCareMemberCareProfileBioIndexRoute,
    AuthenticatedMemberCareMemberCareProfileContactIndexRoute:
      AuthenticatedMemberCareMemberCareProfileContactIndexRoute,
  }

const AuthenticatedMemberCareRouteWithChildren =
  AuthenticatedMemberCareRoute._addFileChildren(
    AuthenticatedMemberCareRouteChildren,
  )

interface AuthenticatedOnboardingRouteChildren {
  AuthenticatedOnboardingOnboardingMemberCareRoute: typeof AuthenticatedOnboardingOnboardingMemberCareRoute
}

const AuthenticatedOnboardingRouteChildren: AuthenticatedOnboardingRouteChildren =
  {
    AuthenticatedOnboardingOnboardingMemberCareRoute:
      AuthenticatedOnboardingOnboardingMemberCareRoute,
  }

const AuthenticatedOnboardingRouteWithChildren =
  AuthenticatedOnboardingRoute._addFileChildren(
    AuthenticatedOnboardingRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedMemberCareRoute: typeof AuthenticatedMemberCareRouteWithChildren
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedMemberCareRoute: AuthenticatedMemberCareRouteWithChildren,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedOnboardingRouteWithChildren
  '/password-setup/$authToken': typeof PasswordSetupAuthTokenRoute
  '/': typeof AuthenticatedIndexRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/login': typeof LoginIndexRoute
  '/sign-in': typeof SignInIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/creator-applications/$applicationId': typeof AuthenticatedAdminCreatorApplicationsApplicationIdRoute
  '/eula/$id': typeof AuthenticatedAdminEulaIdRoute
  '/member-care/$memberCareId': typeof AuthenticatedAdminMemberCareMemberCareIdRoute
  '/organizations/$organizationId': typeof AuthenticatedAdminOrganizationsOrganizationIdRoute
  '/providers/$providerId': typeof AuthenticatedAdminProvidersProviderIdRoute
  '/super-admin/features-management': typeof AuthenticatedAdminSuperAdminFeaturesManagementRoute
  '/super-admin/manual-queues': typeof AuthenticatedAdminSuperAdminManualQueuesRoute
  '/super-admin/metrics': typeof AuthenticatedAdminSuperAdminMetricsRoute
  '/super-admin/organization-access': typeof AuthenticatedAdminSuperAdminOrganizationAccessRoute
  '/onboarding/member-care': typeof AuthenticatedOnboardingOnboardingMemberCareRoute
  '/assessments': typeof AuthenticatedAdminAssessmentsIndexRoute
  '/contracts': typeof AuthenticatedAdminContractsIndexRoute
  '/creator-applications': typeof AuthenticatedAdminCreatorApplicationsIndexRoute
  '/eula': typeof AuthenticatedAdminEulaIndexRoute
  '/member-care': typeof AuthenticatedAdminMemberCareIndexRoute
  '/notifications': typeof AuthenticatedAdminNotificationsIndexRoute
  '/organization-leads': typeof AuthenticatedAdminOrganizationLeadsIndexRoute
  '/organizations': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/providers': typeof AuthenticatedAdminProvidersIndexRoute
  '/assessments/$assessmentId/preview': typeof AuthenticatedAdminAssessmentsAssessmentIdPreviewRoute
  '/content/branded-content/$contentId': typeof AuthenticatedAdminContentBrandedContentContentIdRoute
  '/content/moderation/$contentId': typeof AuthenticatedAdminContentModerationContentIdRoute
  '/member-care/members/$memberCareMemberId': typeof AuthenticatedMemberCareMemberCareMembersMemberCareMemberIdRoute
  '/member-care/organizations/$memberCareOrganizationId': typeof AuthenticatedMemberCareMemberCareOrganizationsMemberCareOrganizationIdRoute
  '/assessments/$assessmentId': typeof AuthenticatedAdminAssessmentsAssessmentIdIndexRoute
  '/content/branded-content': typeof AuthenticatedAdminContentBrandedContentIndexRoute
  '/content/moderation': typeof AuthenticatedAdminContentModerationIndexRoute
  '/providers/create': typeof AuthenticatedAdminProvidersCreateIndexRoute
  '/member-care/members': typeof AuthenticatedMemberCareMemberCareMembersIndexRoute
  '/member-care/profile': typeof AuthenticatedMemberCareMemberCareProfileIndexRoute
  '/content/branded-content/create/$type': typeof AuthenticatedAdminContentBrandedContentCreateTypeRoute
  '/member-care/profile/bio': typeof AuthenticatedMemberCareMemberCareProfileBioIndexRoute
  '/member-care/profile/contact': typeof AuthenticatedMemberCareMemberCareProfileContactIndexRoute
}

export interface FileRoutesByTo {
  '': typeof AuthenticatedOnboardingRouteWithChildren
  '/password-setup/$authToken': typeof PasswordSetupAuthTokenRoute
  '/': typeof AuthenticatedIndexRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/login': typeof LoginIndexRoute
  '/sign-in': typeof SignInIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/creator-applications/$applicationId': typeof AuthenticatedAdminCreatorApplicationsApplicationIdRoute
  '/eula/$id': typeof AuthenticatedAdminEulaIdRoute
  '/member-care/$memberCareId': typeof AuthenticatedAdminMemberCareMemberCareIdRoute
  '/organizations/$organizationId': typeof AuthenticatedAdminOrganizationsOrganizationIdRoute
  '/providers/$providerId': typeof AuthenticatedAdminProvidersProviderIdRoute
  '/super-admin/features-management': typeof AuthenticatedAdminSuperAdminFeaturesManagementRoute
  '/super-admin/manual-queues': typeof AuthenticatedAdminSuperAdminManualQueuesRoute
  '/super-admin/metrics': typeof AuthenticatedAdminSuperAdminMetricsRoute
  '/super-admin/organization-access': typeof AuthenticatedAdminSuperAdminOrganizationAccessRoute
  '/onboarding/member-care': typeof AuthenticatedOnboardingOnboardingMemberCareRoute
  '/assessments': typeof AuthenticatedAdminAssessmentsIndexRoute
  '/contracts': typeof AuthenticatedAdminContractsIndexRoute
  '/creator-applications': typeof AuthenticatedAdminCreatorApplicationsIndexRoute
  '/eula': typeof AuthenticatedAdminEulaIndexRoute
  '/member-care': typeof AuthenticatedAdminMemberCareIndexRoute
  '/notifications': typeof AuthenticatedAdminNotificationsIndexRoute
  '/organization-leads': typeof AuthenticatedAdminOrganizationLeadsIndexRoute
  '/organizations': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/providers': typeof AuthenticatedAdminProvidersIndexRoute
  '/assessments/$assessmentId/preview': typeof AuthenticatedAdminAssessmentsAssessmentIdPreviewRoute
  '/content/branded-content/$contentId': typeof AuthenticatedAdminContentBrandedContentContentIdRoute
  '/content/moderation/$contentId': typeof AuthenticatedAdminContentModerationContentIdRoute
  '/member-care/members/$memberCareMemberId': typeof AuthenticatedMemberCareMemberCareMembersMemberCareMemberIdRoute
  '/member-care/organizations/$memberCareOrganizationId': typeof AuthenticatedMemberCareMemberCareOrganizationsMemberCareOrganizationIdRoute
  '/assessments/$assessmentId': typeof AuthenticatedAdminAssessmentsAssessmentIdIndexRoute
  '/content/branded-content': typeof AuthenticatedAdminContentBrandedContentIndexRoute
  '/content/moderation': typeof AuthenticatedAdminContentModerationIndexRoute
  '/providers/create': typeof AuthenticatedAdminProvidersCreateIndexRoute
  '/member-care/members': typeof AuthenticatedMemberCareMemberCareMembersIndexRoute
  '/member-care/profile': typeof AuthenticatedMemberCareMemberCareProfileIndexRoute
  '/content/branded-content/create/$type': typeof AuthenticatedAdminContentBrandedContentCreateTypeRoute
  '/member-care/profile/bio': typeof AuthenticatedMemberCareMemberCareProfileBioIndexRoute
  '/member-care/profile/contact': typeof AuthenticatedMemberCareMemberCareProfileContactIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/_admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/_member-care': typeof AuthenticatedMemberCareRouteWithChildren
  '/_authenticated/_onboarding': typeof AuthenticatedOnboardingRouteWithChildren
  '/password-setup/$authToken': typeof PasswordSetupAuthTokenRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/forgot-password/': typeof ForgotPasswordIndexRoute
  '/login/': typeof LoginIndexRoute
  '/sign-in/': typeof SignInIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/_admin/creator-applications/$applicationId': typeof AuthenticatedAdminCreatorApplicationsApplicationIdRoute
  '/_authenticated/_admin/eula/$id': typeof AuthenticatedAdminEulaIdRoute
  '/_authenticated/_admin/member-care/$memberCareId': typeof AuthenticatedAdminMemberCareMemberCareIdRoute
  '/_authenticated/_admin/organizations/$organizationId': typeof AuthenticatedAdminOrganizationsOrganizationIdRoute
  '/_authenticated/_admin/providers/$providerId': typeof AuthenticatedAdminProvidersProviderIdRoute
  '/_authenticated/_admin/super-admin/features-management': typeof AuthenticatedAdminSuperAdminFeaturesManagementRoute
  '/_authenticated/_admin/super-admin/manual-queues': typeof AuthenticatedAdminSuperAdminManualQueuesRoute
  '/_authenticated/_admin/super-admin/metrics': typeof AuthenticatedAdminSuperAdminMetricsRoute
  '/_authenticated/_admin/super-admin/organization-access': typeof AuthenticatedAdminSuperAdminOrganizationAccessRoute
  '/_authenticated/_onboarding/onboarding/member-care': typeof AuthenticatedOnboardingOnboardingMemberCareRoute
  '/_authenticated/_admin/assessments/': typeof AuthenticatedAdminAssessmentsIndexRoute
  '/_authenticated/_admin/contracts/': typeof AuthenticatedAdminContractsIndexRoute
  '/_authenticated/_admin/creator-applications/': typeof AuthenticatedAdminCreatorApplicationsIndexRoute
  '/_authenticated/_admin/eula/': typeof AuthenticatedAdminEulaIndexRoute
  '/_authenticated/_admin/member-care/': typeof AuthenticatedAdminMemberCareIndexRoute
  '/_authenticated/_admin/notifications/': typeof AuthenticatedAdminNotificationsIndexRoute
  '/_authenticated/_admin/organization-leads/': typeof AuthenticatedAdminOrganizationLeadsIndexRoute
  '/_authenticated/_admin/organizations/': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/_authenticated/_admin/providers/': typeof AuthenticatedAdminProvidersIndexRoute
  '/_authenticated/_admin/assessments/$assessmentId/preview': typeof AuthenticatedAdminAssessmentsAssessmentIdPreviewRoute
  '/_authenticated/_admin/content/branded-content/$contentId': typeof AuthenticatedAdminContentBrandedContentContentIdRoute
  '/_authenticated/_admin/content/moderation/$contentId': typeof AuthenticatedAdminContentModerationContentIdRoute
  '/_authenticated/_member-care/member-care/members/$memberCareMemberId': typeof AuthenticatedMemberCareMemberCareMembersMemberCareMemberIdRoute
  '/_authenticated/_member-care/member-care/organizations/$memberCareOrganizationId': typeof AuthenticatedMemberCareMemberCareOrganizationsMemberCareOrganizationIdRoute
  '/_authenticated/_admin/assessments/$assessmentId/': typeof AuthenticatedAdminAssessmentsAssessmentIdIndexRoute
  '/_authenticated/_admin/content/branded-content/': typeof AuthenticatedAdminContentBrandedContentIndexRoute
  '/_authenticated/_admin/content/moderation/': typeof AuthenticatedAdminContentModerationIndexRoute
  '/_authenticated/_admin/providers/create/': typeof AuthenticatedAdminProvidersCreateIndexRoute
  '/_authenticated/_member-care/member-care/members/': typeof AuthenticatedMemberCareMemberCareMembersIndexRoute
  '/_authenticated/_member-care/member-care/profile/': typeof AuthenticatedMemberCareMemberCareProfileIndexRoute
  '/_authenticated/_admin/content/branded-content/create/$type': typeof AuthenticatedAdminContentBrandedContentCreateTypeRoute
  '/_authenticated/_member-care/member-care/profile/bio/': typeof AuthenticatedMemberCareMemberCareProfileBioIndexRoute
  '/_authenticated/_member-care/member-care/profile/contact/': typeof AuthenticatedMemberCareMemberCareProfileContactIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/password-setup/$authToken'
    | '/'
    | '/forgot-password'
    | '/login'
    | '/sign-in'
    | '/settings'
    | '/creator-applications/$applicationId'
    | '/eula/$id'
    | '/member-care/$memberCareId'
    | '/organizations/$organizationId'
    | '/providers/$providerId'
    | '/super-admin/features-management'
    | '/super-admin/manual-queues'
    | '/super-admin/metrics'
    | '/super-admin/organization-access'
    | '/onboarding/member-care'
    | '/assessments'
    | '/contracts'
    | '/creator-applications'
    | '/eula'
    | '/member-care'
    | '/notifications'
    | '/organization-leads'
    | '/organizations'
    | '/providers'
    | '/assessments/$assessmentId/preview'
    | '/content/branded-content/$contentId'
    | '/content/moderation/$contentId'
    | '/member-care/members/$memberCareMemberId'
    | '/member-care/organizations/$memberCareOrganizationId'
    | '/assessments/$assessmentId'
    | '/content/branded-content'
    | '/content/moderation'
    | '/providers/create'
    | '/member-care/members'
    | '/member-care/profile'
    | '/content/branded-content/create/$type'
    | '/member-care/profile/bio'
    | '/member-care/profile/contact'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/password-setup/$authToken'
    | '/'
    | '/forgot-password'
    | '/login'
    | '/sign-in'
    | '/settings'
    | '/creator-applications/$applicationId'
    | '/eula/$id'
    | '/member-care/$memberCareId'
    | '/organizations/$organizationId'
    | '/providers/$providerId'
    | '/super-admin/features-management'
    | '/super-admin/manual-queues'
    | '/super-admin/metrics'
    | '/super-admin/organization-access'
    | '/onboarding/member-care'
    | '/assessments'
    | '/contracts'
    | '/creator-applications'
    | '/eula'
    | '/member-care'
    | '/notifications'
    | '/organization-leads'
    | '/organizations'
    | '/providers'
    | '/assessments/$assessmentId/preview'
    | '/content/branded-content/$contentId'
    | '/content/moderation/$contentId'
    | '/member-care/members/$memberCareMemberId'
    | '/member-care/organizations/$memberCareOrganizationId'
    | '/assessments/$assessmentId'
    | '/content/branded-content'
    | '/content/moderation'
    | '/providers/create'
    | '/member-care/members'
    | '/member-care/profile'
    | '/content/branded-content/create/$type'
    | '/member-care/profile/bio'
    | '/member-care/profile/contact'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/_admin'
    | '/_authenticated/_member-care'
    | '/_authenticated/_onboarding'
    | '/password-setup/$authToken'
    | '/_authenticated/'
    | '/forgot-password/'
    | '/login/'
    | '/sign-in/'
    | '/_authenticated/settings/'
    | '/_authenticated/_admin/creator-applications/$applicationId'
    | '/_authenticated/_admin/eula/$id'
    | '/_authenticated/_admin/member-care/$memberCareId'
    | '/_authenticated/_admin/organizations/$organizationId'
    | '/_authenticated/_admin/providers/$providerId'
    | '/_authenticated/_admin/super-admin/features-management'
    | '/_authenticated/_admin/super-admin/manual-queues'
    | '/_authenticated/_admin/super-admin/metrics'
    | '/_authenticated/_admin/super-admin/organization-access'
    | '/_authenticated/_onboarding/onboarding/member-care'
    | '/_authenticated/_admin/assessments/'
    | '/_authenticated/_admin/contracts/'
    | '/_authenticated/_admin/creator-applications/'
    | '/_authenticated/_admin/eula/'
    | '/_authenticated/_admin/member-care/'
    | '/_authenticated/_admin/notifications/'
    | '/_authenticated/_admin/organization-leads/'
    | '/_authenticated/_admin/organizations/'
    | '/_authenticated/_admin/providers/'
    | '/_authenticated/_admin/assessments/$assessmentId/preview'
    | '/_authenticated/_admin/content/branded-content/$contentId'
    | '/_authenticated/_admin/content/moderation/$contentId'
    | '/_authenticated/_member-care/member-care/members/$memberCareMemberId'
    | '/_authenticated/_member-care/member-care/organizations/$memberCareOrganizationId'
    | '/_authenticated/_admin/assessments/$assessmentId/'
    | '/_authenticated/_admin/content/branded-content/'
    | '/_authenticated/_admin/content/moderation/'
    | '/_authenticated/_admin/providers/create/'
    | '/_authenticated/_member-care/member-care/members/'
    | '/_authenticated/_member-care/member-care/profile/'
    | '/_authenticated/_admin/content/branded-content/create/$type'
    | '/_authenticated/_member-care/member-care/profile/bio/'
    | '/_authenticated/_member-care/member-care/profile/contact/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PasswordSetupAuthTokenRoute: typeof PasswordSetupAuthTokenRoute
  ForgotPasswordIndexRoute: typeof ForgotPasswordIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  SignInIndexRoute: typeof SignInIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PasswordSetupAuthTokenRoute: PasswordSetupAuthTokenRoute,
  ForgotPasswordIndexRoute: ForgotPasswordIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  SignInIndexRoute: SignInIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/password-setup/$authToken",
        "/forgot-password/",
        "/login/",
        "/sign-in/"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/_admin",
        "/_authenticated/_member-care",
        "/_authenticated/_onboarding",
        "/_authenticated/",
        "/_authenticated/settings/"
      ]
    },
    "/_authenticated/_admin": {
      "filePath": "_authenticated/_admin.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_admin/creator-applications/$applicationId",
        "/_authenticated/_admin/eula/$id",
        "/_authenticated/_admin/member-care/$memberCareId",
        "/_authenticated/_admin/organizations/$organizationId",
        "/_authenticated/_admin/providers/$providerId",
        "/_authenticated/_admin/super-admin/features-management",
        "/_authenticated/_admin/super-admin/manual-queues",
        "/_authenticated/_admin/super-admin/metrics",
        "/_authenticated/_admin/super-admin/organization-access",
        "/_authenticated/_admin/assessments/",
        "/_authenticated/_admin/contracts/",
        "/_authenticated/_admin/creator-applications/",
        "/_authenticated/_admin/eula/",
        "/_authenticated/_admin/member-care/",
        "/_authenticated/_admin/notifications/",
        "/_authenticated/_admin/organization-leads/",
        "/_authenticated/_admin/organizations/",
        "/_authenticated/_admin/providers/",
        "/_authenticated/_admin/assessments/$assessmentId/preview",
        "/_authenticated/_admin/content/branded-content/$contentId",
        "/_authenticated/_admin/content/moderation/$contentId",
        "/_authenticated/_admin/assessments/$assessmentId/",
        "/_authenticated/_admin/content/branded-content/",
        "/_authenticated/_admin/content/moderation/",
        "/_authenticated/_admin/providers/create/",
        "/_authenticated/_admin/content/branded-content/create/$type"
      ]
    },
    "/_authenticated/_member-care": {
      "filePath": "_authenticated/_member-care.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_member-care/member-care/members/$memberCareMemberId",
        "/_authenticated/_member-care/member-care/organizations/$memberCareOrganizationId",
        "/_authenticated/_member-care/member-care/members/",
        "/_authenticated/_member-care/member-care/profile/",
        "/_authenticated/_member-care/member-care/profile/bio/",
        "/_authenticated/_member-care/member-care/profile/contact/"
      ]
    },
    "/_authenticated/_onboarding": {
      "filePath": "_authenticated/_onboarding.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_onboarding/onboarding/member-care"
      ]
    },
    "/password-setup/$authToken": {
      "filePath": "password-setup/$authToken.tsx"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/forgot-password/": {
      "filePath": "forgot-password/index.tsx"
    },
    "/login/": {
      "filePath": "login/index.tsx"
    },
    "/sign-in/": {
      "filePath": "sign-in/index.tsx"
    },
    "/_authenticated/settings/": {
      "filePath": "_authenticated/settings/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/_admin/creator-applications/$applicationId": {
      "filePath": "_authenticated/_admin/creator-applications/$applicationId.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/eula/$id": {
      "filePath": "_authenticated/_admin/eula/$id.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/member-care/$memberCareId": {
      "filePath": "_authenticated/_admin/member-care/$memberCareId.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/organizations/$organizationId": {
      "filePath": "_authenticated/_admin/organizations/$organizationId.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/providers/$providerId": {
      "filePath": "_authenticated/_admin/providers/$providerId.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/super-admin/features-management": {
      "filePath": "_authenticated/_admin/super-admin/features-management.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/super-admin/manual-queues": {
      "filePath": "_authenticated/_admin/super-admin/manual-queues.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/super-admin/metrics": {
      "filePath": "_authenticated/_admin/super-admin/metrics.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/super-admin/organization-access": {
      "filePath": "_authenticated/_admin/super-admin/organization-access.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_onboarding/onboarding/member-care": {
      "filePath": "_authenticated/_onboarding/onboarding.member-care.tsx",
      "parent": "/_authenticated/_onboarding"
    },
    "/_authenticated/_admin/assessments/": {
      "filePath": "_authenticated/_admin/assessments/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/contracts/": {
      "filePath": "_authenticated/_admin/contracts/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/creator-applications/": {
      "filePath": "_authenticated/_admin/creator-applications/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/eula/": {
      "filePath": "_authenticated/_admin/eula/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/member-care/": {
      "filePath": "_authenticated/_admin/member-care/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/notifications/": {
      "filePath": "_authenticated/_admin/notifications/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/organization-leads/": {
      "filePath": "_authenticated/_admin/organization-leads/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/organizations/": {
      "filePath": "_authenticated/_admin/organizations/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/providers/": {
      "filePath": "_authenticated/_admin/providers/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/assessments/$assessmentId/preview": {
      "filePath": "_authenticated/_admin/assessments/$assessmentId/preview.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/content/branded-content/$contentId": {
      "filePath": "_authenticated/_admin/content/branded-content/$contentId.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/content/moderation/$contentId": {
      "filePath": "_authenticated/_admin/content/moderation/$contentId.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_member-care/member-care/members/$memberCareMemberId": {
      "filePath": "_authenticated/_member-care/member-care/members/$memberCareMemberId.tsx",
      "parent": "/_authenticated/_member-care"
    },
    "/_authenticated/_member-care/member-care/organizations/$memberCareOrganizationId": {
      "filePath": "_authenticated/_member-care/member-care/organizations/$memberCareOrganizationId.tsx",
      "parent": "/_authenticated/_member-care"
    },
    "/_authenticated/_admin/assessments/$assessmentId/": {
      "filePath": "_authenticated/_admin/assessments/$assessmentId/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/content/branded-content/": {
      "filePath": "_authenticated/_admin/content/branded-content/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/content/moderation/": {
      "filePath": "_authenticated/_admin/content/moderation/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_admin/providers/create/": {
      "filePath": "_authenticated/_admin/providers/create/index.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_member-care/member-care/members/": {
      "filePath": "_authenticated/_member-care/member-care/members/index.tsx",
      "parent": "/_authenticated/_member-care"
    },
    "/_authenticated/_member-care/member-care/profile/": {
      "filePath": "_authenticated/_member-care/member-care/profile/index.tsx",
      "parent": "/_authenticated/_member-care"
    },
    "/_authenticated/_admin/content/branded-content/create/$type": {
      "filePath": "_authenticated/_admin/content/branded-content/create/$type.tsx",
      "parent": "/_authenticated/_admin"
    },
    "/_authenticated/_member-care/member-care/profile/bio/": {
      "filePath": "_authenticated/_member-care/member-care/profile/bio/index.tsx",
      "parent": "/_authenticated/_member-care"
    },
    "/_authenticated/_member-care/member-care/profile/contact/": {
      "filePath": "_authenticated/_member-care/member-care/profile/contact/index.tsx",
      "parent": "/_authenticated/_member-care"
    }
  }
}
ROUTE_MANIFEST_END */
